import { g as graphqlRequestClient, a as getHeaders, u as useQuery, b as useMutation } from './graphqlRequestClient-3KYHZKVm.js';

const publicQuery = (apolloProps, options, fetchPolicyKey, ctx, useGetForQueries = false) => {
    const newOptions = {
        ...options,
        context: {
            fetchOptions: { method: useGetForQueries ? 'GET' : 'POST' },
        },
    };
    return graphqlRequestClient(apolloProps.uri)
        .request(options.query, options.variables, getHeaders(apolloProps.store, newOptions, ctx, false, fetchPolicyKey))
        .then(data => ({ data, errors: [] }))
        .catch(error => {
        var _a;
        // Handle both GraphQL errors and network/runtime errors
        const errors = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) || [
            {
                message: error.message || 'An unexpected error occurred',
                extensions: {
                    originalError: error,
                },
            },
        ];
        return { data: null, errors };
    });
};
const privateQuery = (apolloProps, options, fetchPolicyKey, ctx) => graphqlRequestClient(apolloProps.uri)
    .request(options.query, options.variables, getHeaders(apolloProps.store, options, ctx, true, fetchPolicyKey))
    .then(data => ({ data, errors: [] }))
    .catch(error => {
    var _a;
    // Handle both GraphQL errors and network/runtime errors
    const errors = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) || [
        {
            message: error.message || 'An unexpected error occurred',
            extensions: {
                originalError: error,
            },
        },
    ];
    return { data: null, errors };
});
const publicMutate = (apolloProps, options, ctx) => graphqlRequestClient(apolloProps.uri)
    .request(options.mutation, options.variables, getHeaders(apolloProps.store, options, ctx, true))
    .then(data => ({ data, errors: [] }))
    .catch(error => {
    var _a;
    // Handle both GraphQL errors and network/runtime errors
    const errors = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) || [
        {
            message: error.message || 'An unexpected error occurred',
            extensions: {
                originalError: error,
            },
        },
    ];
    return { data: null, errors };
});
const privateMutate = (apolloProps, options, ctx) => graphqlRequestClient(apolloProps.uri)
    .request(options.mutation, options.variables, getHeaders(apolloProps.store, options, ctx, true))
    .then(data => ({ data, errors: [] }))
    .catch(error => {
    var _a;
    // Handle both GraphQL errors and network/runtime errors
    const errors = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) || [
        {
            message: error.message || 'An unexpected error occurred',
            extensions: {
                originalError: error,
            },
        },
    ];
    return { data: null, errors };
});
const usePublicLazyQuery = (apolloProps, query, fetchPolicyKey) => useQuery(apolloProps.uri, query, apolloProps, false, fetchPolicyKey);
const usePrivateLazyQuery = (apolloProps, query, fetchPolicyKey) => useQuery(apolloProps.uri, query, apolloProps, true, fetchPolicyKey);
const usePublicMutation = (apolloProps, mutation, options) => useMutation(apolloProps.uri, mutation, getHeaders(apolloProps.store, options));
const usePrivateMutation = (apolloProps, mutation, options) => useMutation(apolloProps.uri, mutation, getHeaders(apolloProps.store, options, null, true));

export { privateQuery as a, publicMutate as b, privateMutate as c, usePrivateLazyQuery as d, usePublicMutation as e, usePrivateMutation as f, publicQuery as p, usePublicLazyQuery as u };
//# sourceMappingURL=requestsCollection-_VRM28HJ.js.map
